import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import {
    editReportVersionAccessInformationCredentialsRoute,
    reportVersionAccessInformationRoute,
} from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { UpdateReportAccessInformationCredentialsForm } from "app/component/report-access-information-credentials/UpdateReportAccessInformationCredentialsForm.tsx";

export const EditReportVersionAccessInformationCredentialsScreen: FC = () => {
    const { reportId, versionId, credentialsId } = useRouteParams(editReportVersionAccessInformationCredentialsRoute);
    const [created, setUpdated] = useState(false);

    return created ? (
        <Navigate to={reportVersionAccessInformationRoute.build({ reportId, versionId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={editReportVersionAccessInformationCredentialsRoute} />
                <UpdateReportAccessInformationCredentialsForm
                    credentialsId={credentialsId}
                    onUpdate={() => setUpdated(true)}
                />
            </Container>
        </NavigationScreen>
    );
};
